import api from "@/lib/api";

export async function getSolicitacaoByID(id) {
  const { data } = await api.get("/secretaria-digital/solicitacao/dash", { params: { id } })
  return data
}